import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormGroup } from '../../../../../../../components/form/FormGroup';
import { useCurrencyFormatter } from '../../../../../../../hooks/useCurrencyFormatter';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import { useExpenseByIdQuery } from '../../../../../__generated__/graphql';
import ServerError from '../../../../../../../components/ServerError';
import Skeleton from 'react-loading-skeleton';

type Props = {
  expenseId: string;
};

const EMPTY_VALUE = '---';
const i18Path = 'expenses.expenseSideBar';

export const ExpenseDetails: React.FC<Props> = ({ expenseId }) => {
  const t = useNamespacedTranslation(i18Path);
  const formatCurrency = useCurrencyFormatter();

  const { data, loading, error } = useExpenseByIdQuery({
    variables: { id: expenseId },
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ServerError />;
  }

  const expense = data?.expense;

  if (!expense) {
    return <ServerError />;
  }

  return (
    <div className="mt-4">
      <FormGroup>
        <Form.Label className="fw-bold">{t('expenseDescription')}</Form.Label>
        <p>{expense.flair__Description__c}</p>
      </FormGroup>

      <Row>
        <Col>
          <FormGroup>
            <Form.Label className="fw-bold">{t('amount')}</Form.Label>
            <p>
              {formatCurrency({
                value: expense?.flair__Final_Amount__c,
                currency: expense?.CurrencyIsoCode,
              })}
            </p>
          </FormGroup>
        </Col>
      </Row>

      {expense?.project && (
        <Row>
          <Col>
            <FormGroup>
              <Form.Label className="fw-bold">{t('project')}</Form.Label>
              <p>{expense.project?.flair__Name__c ?? EMPTY_VALUE}</p>
            </FormGroup>
          </Col>
        </Row>
      )}
    </div>
  );
};

const Loading: React.FC = () => {
  return (
    <div>
      <Skeleton height={80} />
      <Skeleton height={80} />
      <Skeleton height={80} />
    </div>
  );
};
